export default __webpack_public_path__ + "static/media/cg_birds_view.02f2dd45.jpg";